import React from "react";
import { WrappedFieldProps } from "redux-form";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Stack from '@mui/material/Stack';
import Add from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import Chip from "@mui/material/Chip";
import TextField from "@mui/material/TextField";

import { IMedAppFormField } from ".";

type MultiInputChipWrapperProps = WrappedFieldProps & IMedAppFormField;

const MultiInputChip: React.FC<MultiInputChipWrapperProps> = ({
  placeholder,
  input,
  label,
  meta: { touched, error },
  inputExtras,
  defaultValue,
}) => {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [values, setValues] = React.useState<string[]>([]);
  const [prefix, setPrefix] = React.useState("multi-chip-");

  const onDelete = (index: number) => {
    if (index >= values.length) {
      return;
    }
    const newArray = Array.from(values);
    newArray.splice(index, 1);
    if (newArray.length === 0) {
      input.onChange("");
    } else {
      input.onChange(newArray.join(","));
    }
  };

  const onPress = () => {
    if (inputRef.current === null) {
      return;
    }
    if (inputRef.current.value.length === 0) {
        return;
      }
      if(values.length === 0) {
        input.onChange(inputRef.current.value);
        return;
      }
    const next = values.join(",") + "," + inputRef.current.value;
    input.onChange(next);
  };

  React.useEffect(() => {
    if(input.value.length > 0) setValues(input.value.split(","));
    else if(defaultValue) {
      input.onChange(defaultValue);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input.value, defaultValue]);
  React.useEffect(() => {
    if (inputExtras && inputExtras["prefix"]) {
      setPrefix(inputExtras["prefix"]);
    }
  }, [inputExtras]);
  return (
    <>
    
      <TextField
        label={label}
 
        onFocus={input.onFocus}
        placeholder={placeholder}
        helperText={error}
        error={!!error && touched}
        sx={{
            width: '100%'
        }}
        inputRef={inputRef}
        InputProps={{


          endAdornment: (
              <InputAdornment position="end">

                <IconButton onClick={onPress}>
                <Add />
                </IconButton>
              </InputAdornment>
          ),
        }}
      />
       <Stack mt={1}    sx={{ flexWrap: 'wrap', gap: 1 }} direction="row" spacing={1}>
      {values.map((s: any, index: any) => (
        <Chip
          variant="outlined"
          color="default"
          key={prefix + index}
          deleteIcon={<DeleteIcon />}
          onDelete={() => {
            onDelete(index);
          }}
          label={s} />
      ))}
      </Stack>
    </>
  );
};


export default MultiInputChip;
